import { useEffect } from "react";

/**
 * Lightweight per-route SEO helper.
 * Sets document.title and the key meta tags (description, OG, Twitter, canonical).
 * Social crawlers read index.html (served with defaults); this keeps the
 * browser tab / share previews accurate when users navigate client-side.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
}) {
  useEffect(() => {
    const origin = "https://myprocraft.com";
    const url = `${origin}${path}`;
    const fullTitle = title
      ? `${title} | ProCraft Solutions`
      : "ProCraft Solutions | Landscaping, Lawn Care & Property Services in Tampa Bay, FL";

    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, name] = selector.replace(/[[\]]/g, "").split("=");
        el.setAttribute(key, name.replace(/['"]/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }

    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[property="og:url"]', "content", url);

    if (image) {
      setMeta('meta[property="og:image"]', "content", image);
      setMeta('meta[name="twitter:image"]', "content", image);
    }

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image]);

  return null;
}
